module.exports = __webpack_public_path__ + "static/img/Drinks.315fa24.png";